import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker } from "@/lib/registerSW";

// OPS-01: frontend error monitoring. No-op until REACT_APP_SENTRY_DSN is set,
// so it is safe to ship. Error monitoring only — traces 0.1, no logs/metrics/replay.
const _sentryDsn = process.env.REACT_APP_SENTRY_DSN;
if (_sentryDsn) {
  Sentry.init({
    dsn: _sentryDsn,
    environment: process.env.REACT_APP_ENV || "production",
    tracesSampleRate: 0.1,
    sendDefaultPii: false,
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

registerServiceWorker();
